import { TimesheetRowProps } from '@api/models/timesheet-row';
import { toMoment } from '../date';
import { sortByDates } from '../sortByDates';

export const sortTimesheet = (rows: TimesheetRowProps[]) => sortByDates(rows, 'from')
	.sort((a, b) => {
		const bDate = toMoment(b.from);
		const aDate = toMoment(a.from);

		if (aDate.isSame(bDate) && a.demurrageStarts) {
			return -1;
		}

		if (bDate.isSame(aDate) && b.demurrageStarts) {
			return 1;
		}

		return 0;
	});
